export const social = [
  {
    icon: 'youtube',
    href: 'https://www.youtube.com/channel/UCvM-0XM306291idcd6u5vig',
  },
  {
    icon: 'instagram',
    href: 'https://www.instagram.com/waras.delivery/',
  },
];
